import {takeLatest, call, fork, put} from 'redux-saga/effects';

import {ReportingApi} from 'static/three-oh/src/modules/apis';
import {toReadingSummaryReportingFilters} from 'static/three-oh/src/routes/Binder/modules/selectors/filterSelectors';

import {studentTabActions as actions} from '../actions';
import {studentTabActionTypes} from '../constants';


function * getStudentData(binderFilters, showAssignedWorkOnly) {
  const reportingFilters = toReadingSummaryReportingFilters(binderFilters, showAssignedWorkOnly);

  // Measures with well behaved filters:
  const studentQueryParams = {
    measures: [
      'count:header_views',
      'sum:reading_time',
      'avg:quiz_score',
      'count:quizzes',
      'avg:write_response_score',
      'count:write_response_score',
      'count:annotations',
      'count:vocabulary_questions_correct',
      'count:vocabulary_questions',
    ],
    dimensions: [
      'student_id',
    ],
    filters: reportingFilters,
  };

  try {
    yield put(actions.getBinderStudentsRequest());
    const [students] = yield [
      call(ReportingApi.getReport, studentQueryParams),
    ];

    yield put(actions.getBinderStudentsSuccess({data: students.data, filters: reportingFilters}));
  } catch (error) {
    yield put(actions.getBinderStudentsFailure(error));
  }
}


export function * watchInitStudentTab() {
  yield takeLatest(studentTabActionTypes.INITIALIZE_STUDENT_TAB, function * init(action) {
    const {binderFilters, showAssignedWorkOnly} = action.payload;
    yield fork(getStudentData, binderFilters, showAssignedWorkOnly);
  });
}
